module.exports = __webpack_public_path__ + "static/media/trueblood.8f99ed5f.mp3";